var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-logo-container",
      class: { collapse: _vm.collapse },
    },
    [
      _c(
        "transition",
        { attrs: { name: "sidebarLogoFade" } },
        [
          _vm.collapse
            ? _c(
                "router-link",
                {
                  key: "collapse",
                  staticClass: "sidebar-logo-link mt8",
                  attrs: { to: "/" },
                },
                [
                  _c("img", {
                    staticClass: "header-logo hidden-switch",
                    attrs: {
                      src: _vm.$store.getters.isAruxpay
                        ? require("@/assets/logo/aruxpay_logo_small.svg")
                        : require("@/assets/logo/logo_moneypay_small.svg"),
                      height: "40",
                    },
                  }),
                ]
              )
            : _c(
                "router-link",
                {
                  key: "expand",
                  staticClass: "sidebar-logo-link mt15",
                  attrs: { to: "/" },
                },
                [
                  _c("img", {
                    staticClass: "header-logo",
                    attrs: {
                      src: _vm.$store.getters.isAruxpay
                        ? require("@/assets/logo/aruxpay_logo.png")
                        : require("@/assets/logo/ezpay_logo.svg"),
                      height: "45",
                    },
                  }),
                  _c("h1", { staticClass: "sidebar-title" }, [
                    _vm._v(_vm._s(_vm.title) + " "),
                  ]),
                ]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }